// EXAMPLE FUNCTION FOR ROUTES

import { responseObject } from "../../classes/types/class-user.types";

async function sendRegisterRequest(username: string, password: string): Promise<responseObject | null> {
    try {
        const response: Response = await fetch(`${viteConfiguration.API_URL}user/register/add`, {
            method: "post",
            headers: {
                "Content-Type": "application/json",
            },
            body: JSON.stringify({ username, password }),
        });

        const data: any = await response.json();

        if (!data) {
            return null;
        }

        return data;
    } catch (error) {
        console.error(error);
        return null;
    }
}

export default sendRegisterRequest;
